<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { round } from '../helpers';

  import type { CalculatedInfo } from "../samples";

  import { Button, Col, Chip, Icon, Row, Slider } from 'svelte-materialify/src';
  import { mdiSpeedometer, mdiSpeedometerMedium, mdiSpeedometerSlow, mdiUndo } from '@mdi/js';
  
  export let calculatedInfo: CalculatedInfo;

  const dispatch = createEventDispatcher();  

  let min: number = 0;
  let max: number = 100;
  const stepSize: number = 1;
  let bpmCurrent: number = 0;

  const updateSlider = (calculatedInfo) => {
    if (!calculatedInfo) {
      return;
    }

    min = round(calculatedInfo.bpm * 0.5);
    max = round(calculatedInfo.bpm * 1.5);
    bpmCurrent = round(calculatedInfo.playbackRate * calculatedInfo.bpm, 2);
  };

  const updatePlaybackRate = (ev: CustomEvent) => {
    bpmCurrent = ev.detail.value[0];
    const playbackRate = round(bpmCurrent / calculatedInfo.bpm);
    dispatch('updatePlaybackRate', playbackRate);
  };

  const resetPlaybackRate = () => {
    bpmCurrent = round(calculatedInfo.bpm);
    const playbackRate = 1;
    dispatch('updatePlaybackRate', playbackRate);
  };


  $: updateSlider(calculatedInfo);
    
</script>

<Row dense>
  {#if calculatedInfo}
  <Col cols={12} sm={8}>
    <Slider value={bpmCurrent} {min} {max} step={stepSize} on:change={updatePlaybackRate} >
      Pitch
    </Slider>
  </Col>
  <Col cols={12} sm={4} class="text-right">
    <Chip label>{bpmCurrent} bpm</Chip>
    <Chip label>
      {#if calculatedInfo.playbackRate > 1}
        <Icon path={mdiSpeedometer} />
      {:else if calculatedInfo.playbackRate < 1}
        <Icon path={mdiSpeedometerSlow} />
      {:else}
        <Icon path={mdiSpeedometerMedium} />
      {/if}
      
      <span>{round(calculatedInfo.playbackRate, 2)} x</span>
    </Chip>

    <Button icon disabled={calculatedInfo.playbackRate == 1}
      title="Reset pitch" on:click={resetPlaybackRate}>
      <Icon path={mdiUndo} />
    </Button>

  </Col>
  {/if }
</Row>